import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquitooltip',
	templateUrl:'./JQUITooltipPage.html',
	styles: [],
	styleUrls:['./JQUITooltipPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUITooltipPage
{
	mdContent_231 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.tooltip.JQUITooltip;
\`\`\``;
	mdContent_232 = `\`\`\`java
new JQUITooltip&lt;&gt;()
\`\`\``;
	mdContent_233 = `\`\`\`java
var tip = new JQUITooltip<>();
tip.getOptions().setContent("Helpful information");
tip.getOptions().setTrack(true);
\`\`\``;
}
